itsoftApp.createModule("disclaimer", ["pageLoad", "cookie"], function () {
    const module = this;
    const bodyEnd = document.querySelector(".js-padding-bottom");

    const Disclaimer = function () {
        this.scrollTriggerElement = null;
        this.disclaimerWrapper = document.querySelector(".js-disclaimer-wrapper");
        this.scrollSmootherUsed = false;
        this.disclaimerPosition = null; /* сохраняем сюда элемент, где визуально должен находиться дисклеймер в состоянии static или inactive; пока не используется */
        this.footer = document.querySelector(".page-footer");
        this.disclaimer = document.querySelector(".js-disclaimer"); /* У дисклеймера должен быть такой класс */
        this.state = "static";
        this.gap = 0;
        this.cookies = document.querySelector(".js-cookies");
        this.button = document.querySelector(".disclaimer__close-button"); /* Крестик */
        this.confirm = document.querySelector(".disclaimer__confirm"); /* элемент подтвеждения закрытия */
        this.text = document.querySelector(".disclaimer__text");
        this.disclaimerParts = document.querySelectorAll(".disclaimer__part");
        this.footerCoordY;
        this.sTop;
        this.requiredPercentage = 8;

        if (this.disclaimer) {
            this.init();
            this.onScroll = this.onDocumentScroll.bind(this);
            this.onResize = this.onDocumentResize.bind(this);
        }
    };

    /**
     * Возвращает true, если viewport находится в мобильном/планшетном диапазоне (<=1023px).
     * Брейкпоинт совпадает с `+below(desktop)` из вёрстки (desktop = bp-tab-l = 1023px).
     */
    Disclaimer.prototype.isMobileViewport = function () {
        return window.matchMedia("(max-width: 1023px)").matches;
    };

    /**
     * Подставляет плашке cookies правильное значение bottom.
     *
     * На десктопе:
     *   - дисклеймер активен  -> cookies приподнята на высоту дисклеймера;
     *   - дисклеймер неактивен -> cookies прижата к низу экрана (bottom: 0).
     *
     * На мобилке/планшете (<=1023px):
     *   у дисклеймера в стилях стоит `position: fixed !important`, и он
     *   физически остаётся внизу даже при js-inactive / js-static.
     *   Поэтому cookies здесь ВСЕГДА держим выше на высоту дисклеймера —
     *   иначе плашка налезает поверх дисклеймера.
     *
     * @param {boolean} disclaimerVisuallyActive — состояние дисклеймера
     *        с точки зрения класса (active/inactive), как его видит вызывающий код.
     */
    Disclaimer.prototype.applyCookiesBottom = function (disclaimerVisuallyActive) {
        const DISCLAIMER = this;

        if (!DISCLAIMER.cookies) {
            return;
        }

        const keepAboveDisclaimer = disclaimerVisuallyActive || DISCLAIMER.isMobileViewport();

        if (keepAboveDisclaimer) {
            const measuredHeight = DISCLAIMER.disclaimer.getBoundingClientRect().height;
            const height = itsoftApp.calculations.disclaimerHeight || measuredHeight;
            DISCLAIMER.height = height;
            DISCLAIMER.cookies.style.bottom = (height + DISCLAIMER.gap) + "px";
        } else {
            DISCLAIMER.cookies.style.bottom = "0px";
        }
    };

    Disclaimer.prototype.buttonMouseOver = function () {
        const DISCLAIMER = this;
        if (!this.disclaimer.classList.contains("js-hover")) {
            this.disclaimer.classList.add("js-hover");
            if (this.confirm) {
                this.confirm.addEventListener("mouseleave", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
            }
        }
    };

    Disclaimer.prototype.buttonMouseOut = function () {
        const DISCLAIMER = this;
        this.disclaimer.classList.remove("js-hover");
        this.confirm.removeEventListener("mouseleave", DISCLAIMER.buttonMouseOut.bind(DISCLAIMER));
    };

    Disclaimer.prototype.close = function () {
        const DISCLAIMER = this;
        itsoftApp.modules.cookie.setCookie(DISCLAIMER.disclaimer);
        this.state = "static";
        this.disclaimer.classList.add("js-static");
        this.disclaimer.classList.add("js-inactive");
        if (this.disclaimer.classList.contains("js-hover")) {
            this.disclaimer.classList.remove("js-hover");
        }
        if (this.confirm) {
            this.confirm.style.display = "none";
        }
        if (this.disclaimerWrapper) {
            this.disclaimerWrapper.appendChild(this.disclaimer);
        }
        this.footer.classList.add("js-update");

        if (!DISCLAIMER.scrollSmootherUsed) {
            document.removeEventListener("scroll", DISCLAIMER.onScroll);
        }

        window.removeEventListener("resize", DISCLAIMER.onResize);

        /* Сохраняем cookies на высоте дисклеймера на мобиле (там дисклеймер
           всё ещё фиксирован), иначе опускаем к низу экрана. */
        DISCLAIMER.applyCookiesBottom(false);

        // if (bodyEnd) {
        //     bodyEnd.style.paddingBottom = 0;
        // }
    };

    Disclaimer.prototype.checkButton = function () {
        const DISCLAIMER = this;
        if (DISCLAIMER.button) {
            DISCLAIMER.button.addEventListener("mouseover", DISCLAIMER.buttonMouseOver.bind(DISCLAIMER));

            DISCLAIMER.button.addEventListener("click", function (evt) {
                evt.preventDefault();
                this.close = DISCLAIMER.close();
            });
        }
    };

    Disclaimer.prototype.checkConfirm = function () {
        const DISCLAIMER = this;
        if (DISCLAIMER.confirm) {
            DISCLAIMER.confirm.addEventListener("click", function (evt) {
                evt.preventDefault();
                this.close = DISCLAIMER.close();
            });
        }
    };

    Disclaimer.prototype.defineCoordY = function () {
        const DISCLAIMER = this;
        DISCLAIMER.footerCoordY = DISCLAIMER.footer.getBoundingClientRect().top + pageYOffset;
    };

    /* Вычисляем координаты. Если мы прокрутили страницу до подвала, делаем дисклеймер статичным */
    Disclaimer.prototype.checkElementCoords = function () {
        const DISCLAIMER = this;
        let reVerified = false;
        this.sTop = pageYOffset;

        if (this.sTop > 200 && !reVerified) { // изредка неправильно определяет координаты сразу после полной загрузки страницы, поэтом нужна одна доп. проверка
            reVerified = true;
            DISCLAIMER.defineCoordY();
        }

        if (this.sTop + document.documentElement.clientHeight > this.footerCoordY) {
            if (this.disclaimerWrapper) {
                this.disclaimerWrapper.appendChild(this.disclaimer);
                DISCLAIMER.defineCoordY();
            }

            if (DISCLAIMER.state != "inactive") {
                DISCLAIMER.state = "inactive";

                // if (bodyEnd) {
                //     bodyEnd.style.paddingBottom = 0;
                // }
            }

            if (this.button) {
                this.button.classList.add("js-close-hide");
            }
            this.disclaimer.classList.add("js-inactive");
            /* На мобиле/планшете дисклеймер визуально остаётся фиксированным
               из-за `+below(desktop) position: fixed !important;`,
               поэтому cookies там нельзя опускать к низу экрана —
               applyCookiesBottom сам учтёт ширину окна. */
            DISCLAIMER.applyCookiesBottom(false);
        } else if (!this.disclaimer.classList.contains("js-static")) {
            if (this.disclaimerWrapper) {
                document.body.appendChild(this.disclaimer);
                DISCLAIMER.defineCoordY();
            }

            if (DISCLAIMER.state != "active") {
                DISCLAIMER.state = "active";

                // if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
                //     itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
                //     itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
                // }

                // if (bodyEnd) {
                //     bodyEnd.style.paddingBottom = itsoftApp.calculations.disclaimerHeight + "px";
                // }
            }

            if (this.button) {
                this.button.classList.remove("js-close-hide");
            }
            this.disclaimer.classList.remove("js-inactive");
            /* Дисклеймер активен — cookies должна стоять выше на его высоту.
               applyCookiesBottom сам подстрахует через getBoundingClientRect,
               если itsoftApp.calculations.disclaimerHeight ещё не успел заполниться. */
            DISCLAIMER.applyCookiesBottom(true);
        }
    };

    Disclaimer.prototype.onDocumentScroll = function () {
        const DISCLAIMER = this;
        DISCLAIMER.checkElementCoords();
    };

    Disclaimer.prototype.onDocumentResize = function () {
        /* Обновляем координаты при ресайзе */
        const DISCLAIMER = this;
        DISCLAIMER.calcFontSize();
        DISCLAIMER.defineCoordY();
        /* Передаём текущее активное состояние по классам;
           applyCookiesBottom сам решит, нужно ли всё равно поднимать cookies
           (на мобилке — да, независимо от классов). */
        DISCLAIMER.applyCookiesBottom(DISCLAIMER.state === "active");

        DISCLAIMER.checkElementCoords();
    };

    Disclaimer.prototype.init = function () {
        const DISCLAIMER = this;
        if (DISCLAIMER.disclaimer) {
            /* Инициализируем модуль после полной загрузки страницы, только если на странице есть дисклеймер */
            itsoftApp.modules.pageLoad.addEvent(function () {
                if (DISCLAIMER.disclaimerWrapper) {
                    DISCLAIMER.disclaimerPosition = DISCLAIMER.disclaimerWrapper;
                } else {
                    DISCLAIMER.disclaimerPosition = DISCLAIMER.disclaimer;
                }

                DISCLAIMER.calcFontSize();

                DISCLAIMER.dAttrSave = DISCLAIMER.disclaimer.getAttribute("data-save");

                if (!DISCLAIMER.dAttrSave || (DISCLAIMER.dAttrSave && !itsoftApp.modules.cookie.getCookie(DISCLAIMER.disclaimer))) {
                    DISCLAIMER.defineCoordY();
                    DISCLAIMER.checkElementCoords();
                } else {
                    DISCLAIMER.state = "static";
                    if (DISCLAIMER.disclaimerWrapper) {
                        DISCLAIMER.disclaimerWrapper.appendChild(DISCLAIMER.disclaimer);
                        DISCLAIMER.defineCoordY();
                    }
                    return;
                }

                if (bodyEnd) {
                    if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
                        itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
                        itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
                    }

                    bodyEnd.style.paddingBottom = itsoftApp.calculations.disclaimerHeight + "px";
                }

                if (DISCLAIMER.sTop + document.documentElement.clientHeight > DISCLAIMER.footerCoordY) {
                    DISCLAIMER.state = "inactive";
                } else {
                    if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight) {
                        itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.disclaimerHeight = true;
                        itsoftApp.calculations.disclaimerHeight = itsoftApp.utils.getDisclaimerHeight();
                    }

                    DISCLAIMER.state = "active";
                }

                /* DISCLAIMER.height нужен и без disclaimerWrapper —
                   на него опирается блок выставления cookies.style.bottom внутри applyCookiesBottom. */
                DISCLAIMER.height = DISCLAIMER.disclaimer.getBoundingClientRect().height;

                if (DISCLAIMER.disclaimerWrapper) {
                    DISCLAIMER.disclaimerWrapper.style.height = DISCLAIMER.height + "px";
                }

                /* Финализируем стартовое положение cookies: applyCookiesBottom
                   сам разрулит десктоп/мобилку и активное/неактивное состояние. */
                DISCLAIMER.applyCookiesBottom(DISCLAIMER.state === "active");


                document.addEventListener("scroll", DISCLAIMER.onScroll);
                /* todo: доработать, достать из itsoftApp.calculations.disclaimerHeight */
                window.addEventListener("resize", DISCLAIMER.onResize);
            });

            DISCLAIMER.checkButton();
            DISCLAIMER.checkConfirm();
        }
    };

    Disclaimer.prototype.getWordsSquare = function () {
        let square = 0;

        Array.prototype.forEach.call(this.disclaimerParts, function (word) {
            const blockW = word.clientWidth;
            const blockH = word.clientHeight;
            const currentSquare = blockW * blockH;
            square += currentSquare;
        });

        return square;
    };

    Disclaimer.prototype.getWindowSquare = function () {
        const bodyWidth = itsoftApp.utils.getViewportSize();
        const bodyHeight = itsoftApp.utils.getViewportHeight();
        return bodyWidth * bodyHeight;
    };

    Disclaimer.prototype.getFinalValue = function (square) {
        const percent = square * 100 / this.getWindowSquare();
        return percent > this.requiredPercentage;
    };

    Disclaimer.prototype.setFontSize = function (size) {
        this.text.style.fontSize = size + "px";
        this.text.setAttribute("data-font-size", size);
    };

    Disclaimer.prototype.getFontSize = function () {
        return parseInt(this.text.getAttribute("data-font-size"), 10) || 8;
    };

    Disclaimer.prototype.calcFontSize = function () {
        const DISCLAIMER = this;
        let counter = 0;
        DISCLAIMER.setFontSize(8);
        while (this.getFinalValue(this.getWordsSquare(), this.requiredPercentage) === false) {
            if ( counter++ > 100 ) break;
            DISCLAIMER.setFontSize(DISCLAIMER.getFontSize() + 2);
        }
        const fontSize = this.getFontSize();
        this.text.style.fontSize = fontSize + "px";
    };

    window.DISCLAIMER = new Disclaimer();
    module.callback = Disclaimer;
});
